import type {
  AppUserHoldingLineDTO,
  ClosedTradeLineDTO,
  MonthlyReviewDetailDTO,
  MonthlyReviewListDTO,
  ProfitCurvePointDTO,
  AppUserTradeHistoryLineDTO,
} from "./UserHoldingsType";

/** 与领域层一致：理由类型只能是基本面、消息面、技术面；展示为「类型 : 具体原因」 */
function cnReasonLine(reasonType: "技术面" | "消息面" | "基本面", detail: string): string {
  const d = detail.trim();
  return `${reasonType} : ${d}`;
}

const demoRowsOpen: AppUserHoldingLineDTO[] = [
  {
    holdingId: "UHMOCKOPEN01",
    stockCode: "002594",
    stockName: "比亚迪",
    latestPrice: 258.77,
    todayChangePct: 1.92,
    buyPrice: 250,
    buyTime: "2026-04-09 15:27:30",
    buyShares: 800,
    buyReasonDisplay: cnReasonLine("基本面", "新能源汽车行业龙头，业绩持续增长"),
    positionProfitAmount: 7020,
    positionProfitRatio: 3.51,
    spotPriceSuggest: 258.77,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN02",
    stockCode: "300750",
    stockName: "宁德时代",
    latestPrice: 198.5,
    todayChangePct: 0.85,
    buyPrice: 195,
    buyTime: "2026-04-10 10:15:22",
    buyShares: 500,
    buyReasonDisplay: cnReasonLine("基本面", "动力电池龙头，储能业务放量"),
    positionProfitAmount: 1750,
    positionProfitRatio: 1.79,
    spotPriceSuggest: 198.5,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN03",
    stockCode: "000858",
    stockName: "五粮液",
    latestPrice: 158.2,
    todayChangePct: -0.35,
    buyPrice: 160,
    buyTime: "2026-04-12 14:30:00",
    buyShares: 600,
    buyReasonDisplay: cnReasonLine("基本面", "白酒龙头，品牌价值稳固"),
    positionProfitAmount: -1080,
    positionProfitRatio: -1.13,
    spotPriceSuggest: 158.2,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN04",
    stockCode: "600519",
    stockName: "贵州茅台",
    latestPrice: 1680,
    todayChangePct: 0.42,
    buyPrice: 1650,
    buyTime: "2026-04-15 09:45:30",
    buyShares: 100,
    buyReasonDisplay: cnReasonLine("基本面", "高端白酒绝对龙头"),
    positionProfitAmount: 3000,
    positionProfitRatio: 1.82,
    spotPriceSuggest: 1680,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN05",
    stockCode: "000001",
    stockName: "平安银行",
    latestPrice: 12.5,
    todayChangePct: 1.21,
    buyPrice: 12.2,
    buyTime: "2026-04-16 11:20:00",
    buyShares: 2000,
    buyReasonDisplay: cnReasonLine("基本面", "银行板块估值修复"),
    positionProfitAmount: 600,
    positionProfitRatio: 2.46,
    spotPriceSuggest: 12.5,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN06",
    stockCode: "601318",
    stockName: "中国平安",
    latestPrice: 48.8,
    todayChangePct: 0.62,
    buyPrice: 48.6,
    buyTime: "2026-04-17 13:45:00",
    buyShares: 800,
    buyReasonDisplay: cnReasonLine("基本面", "保险龙头，估值合理"),
    positionProfitAmount: 160,
    positionProfitRatio: 0.41,
    spotPriceSuggest: 48.8,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN07",
    stockCode: "002415",
    stockName: "海康威视",
    latestPrice: 32.5,
    todayChangePct: -0.85,
    buyPrice: 33,
    buyTime: "2026-04-18 10:30:00",
    buyShares: 1000,
    buyReasonDisplay: cnReasonLine("技术面", "安防龙头，回调买入"),
    positionProfitAmount: -500,
    positionProfitRatio: -1.52,
    spotPriceSuggest: 32.5,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN08",
    stockCode: "600036",
    stockName: "招商银行",
    latestPrice: 35.2,
    todayChangePct: 0.95,
    buyPrice: 34.8,
    buyTime: "2026-04-20 14:15:00",
    buyShares: 600,
    buyReasonDisplay: cnReasonLine("基本面", "零售银行龙头"),
    positionProfitAmount: 240,
    positionProfitRatio: 1.15,
    spotPriceSuggest: 35.2,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN09",
    stockCode: "000333",
    stockName: "美的集团",
    latestPrice: 62.5,
    todayChangePct: 0.55,
    buyPrice: 62,
    buyTime: "2026-04-22 09:30:00",
    buyShares: 400,
    buyReasonDisplay: cnReasonLine("基本面", "家电龙头，出海战略清晰"),
    positionProfitAmount: 200,
    positionProfitRatio: 0.81,
    spotPriceSuggest: 62.5,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN10",
    stockCode: "000568",
    stockName: "泸州老窖",
    latestPrice: 185,
    todayChangePct: 1.25,
    buyPrice: 182,
    buyTime: "2026-04-25 11:00:00",
    buyShares: 300,
    buyReasonDisplay: cnReasonLine("基本面", "次高端白酒龙头"),
    positionProfitAmount: 900,
    positionProfitRatio: 1.65,
    spotPriceSuggest: 185,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN11",
    stockCode: "600276",
    stockName: "恒瑞医药",
    latestPrice: 48.5,
    todayChangePct: -0.42,
    buyPrice: 49,
    buyTime: "2026-04-26 14:20:00",
    buyShares: 500,
    buyReasonDisplay: cnReasonLine("基本面", "创新药龙头，研发管线丰富"),
    positionProfitAmount: -250,
    positionProfitRatio: -1.02,
    spotPriceSuggest: 48.5,
    holdingStatus: "OPEN",
  },
  {
    holdingId: "UHMOCKOPEN12",
    stockCode: "300059",
    stockName: "东方财富",
    latestPrice: 18.2,
    todayChangePct: 2.15,
    buyPrice: 17.8,
    buyTime: "2026-04-28 10:45:00",
    buyShares: 1500,
    buyReasonDisplay: cnReasonLine("消息面", "券商板块政策利好"),
    positionProfitAmount: 600,
    positionProfitRatio: 2.25,
    spotPriceSuggest: 18.2,
    holdingStatus: "OPEN",
  },
];

const demoRowsSold: AppUserHoldingLineDTO[] = [
  {
    holdingId: "UHMOCKSOLD01",
    stockCode: "601012",
    stockName: "隆基绿能",
    latestPrice: 22.12,
    todayChangePct: -0.4,
    buyPrice: 22.8,
    buyTime: "2026-02-01 09:35:26",
    buyShares: 1200,
    buyReasonDisplay: cnReasonLine("基本面", "光伏板块景气跟踪，龙头持仓"),
    sellPrice: 23.05,
    sellTime: "2026-05-08 14:56:06",
    sellReasonDisplay: cnReasonLine("技术面", "短期阻力兑现，按计划减仓"),
    holdingStatus: "SOLD",
    positionProfitAmount: 300,
    positionProfitRatio: 1.1,
    spotPriceSuggest: 23.05,
  },
  {
    holdingId: "UHMOCKSOLD02",
    stockCode: "600887",
    stockName: "伊利股份",
    latestPrice: 28.5,
    todayChangePct: 0.35,
    buyPrice: 27.2,
    buyTime: "2026-03-01 10:00:00",
    buyShares: 1000,
    buyReasonDisplay: cnReasonLine("基本面", "乳制品龙头，稳健增长"),
    sellPrice: 28.3,
    sellTime: "2026-05-05 15:30:00",
    sellReasonDisplay: cnReasonLine("基本面", "达到目标价位，获利了结"),
    holdingStatus: "SOLD",
    positionProfitAmount: 1100,
    positionProfitRatio: 4.04,
    spotPriceSuggest: 28.3,
  },
  {
    holdingId: "UHMOCKSOLD03",
    stockCode: "000063",
    stockName: "中兴通讯",
    latestPrice: 32.8,
    todayChangePct: 1.2,
    buyPrice: 30.5,
    buyTime: "2026-03-15 11:20:00",
    buyShares: 800,
    buyReasonDisplay: cnReasonLine("消息面", "5G建设加速，设备商受益"),
    sellPrice: 32.2,
    sellTime: "2026-04-28 14:00:00",
    sellReasonDisplay: cnReasonLine("技术面", "冲高回落，锁定利润"),
    holdingStatus: "SOLD",
    positionProfitAmount: 1360,
    positionProfitRatio: 5.57,
    spotPriceSuggest: 32.2,
  },
  {
    holdingId: "UHMOCKSOLD04",
    stockCode: "600030",
    stockName: "中信证券",
    latestPrice: 22.6,
    todayChangePct: 0.85,
    buyPrice: 21.5,
    buyTime: "2026-03-20 09:45:00",
    buyShares: 1200,
    buyReasonDisplay: cnReasonLine("消息面", "资本市场改革利好券商"),
    sellPrice: 22.4,
    sellTime: "2026-05-02 10:30:00",
    sellReasonDisplay: cnReasonLine("技术面", "量能萎缩，获利了结"),
    holdingStatus: "SOLD",
    positionProfitAmount: 1080,
    positionProfitRatio: 4.19,
    spotPriceSuggest: 22.4,
  },
  {
    holdingId: "UHMOCKSOLD05",
    stockCode: "002230",
    stockName: "科大讯飞",
    latestPrice: 52.8,
    todayChangePct: -0.6,
    buyPrice: 48.5,
    buyTime: "2026-02-20 13:30:00",
    buyShares: 500,
    buyReasonDisplay: cnReasonLine("消息面", "AI大模型商业化加速"),
    sellPrice: 51.2,
    sellTime: "2026-04-20 15:00:00",
    sellReasonDisplay: cnReasonLine("技术面", "前期高点压力，减仓观望"),
    holdingStatus: "SOLD",
    positionProfitAmount: 1350,
    positionProfitRatio: 5.57,
    spotPriceSuggest: 51.2,
  },
  // 超过180天的完结持仓（后端应该过滤掉这些）
  {
    holdingId: "UHMOCKSOLD_OLD01",
    stockCode: "000002",
    stockName: "万科A",
    latestPrice: 15.2,
    todayChangePct: -0.25,
    buyPrice: 18.5,
    buyTime: "2025-09-01 10:00:00",
    buyShares: 1000,
    buyReasonDisplay: cnReasonLine("基本面", "地产龙头，估值低"),
    sellPrice: 16.8,
    sellTime: "2025-10-15 14:30:00",
    sellReasonDisplay: cnReasonLine("基本面", "行业下行，止损离场"),
    holdingStatus: "SOLD",
    positionProfitAmount: -1700,
    positionProfitRatio: -9.19,
    spotPriceSuggest: 16.8,
  },
];

function isSoldWithin180Days(sellTime?: string): boolean {
  const st = sellTime?.trim();
  if (!st) {
    return false;
  }
  const t = Date.parse(st.replace(/-/g, "/"));
  if (Number.isNaN(t)) {
    return false;
  }
  const cutoff = Date.now() - 180 * 24 * 60 * 60 * 1000;
  return t >= cutoff;
}

const histRows: AppUserTradeHistoryLineDTO[] = [
  {
    stockCode: "002594",
    stockName: "比亚迪",
    bizTypeDisplay: "建仓",
    unitPrice: 248,
    grossAmount: 148800,
    shares: 600,
    bizTime: "2026-04-04 09:35:00",
    reasonDisplay: cnReasonLine(
      "基本面",
      "新能源车渗透率与出口放量仍在延续，公司在垂直整合与规模效应下单车盈利路径清晰。结合补贴退坡后的行业出清格局，龙头份额与现金流更具确定性，故在建仓价位布入底仓，后续以月度销量与毛利率变动作为调仓依据。",
    ),
  },
  {
    stockCode: "300750",
    stockName: "宁德时代",
    bizTypeDisplay: "买入",
    unitPrice: 195,
    grossAmount: 58500,
    shares: 300,
    bizTime: "2026-04-05 11:05:00",
    reasonDisplay: cnReasonLine(
      "基本面",
      "动力电池与储能双轮需求在排产与招标层面出现改善，龙头在客户结构与成本曲线上的优势仍在扩大。当前定价已部分反映景气波动，因而在基本面确认窗口完成建仓，并关注单位盈利修复节奏及海外订单占比变化。",
    ),
  },
  {
    stockCode: "601318",
    stockName: "中国平安",
    bizTypeDisplay: "买入",
    unitPrice: 48.6,
    grossAmount: 38880,
    shares: 800,
    bizTime: "2026-04-10 14:00:00",
    reasonDisplay: cnReasonLine(
      "基本面",
      "负债端改革与销售结构优化带来NBV边际改善预期，投资端在利率与权益波动中更注重久期匹配。估值已处于历史偏低分位，适合以中长期视角布局修复，建仓后持续跟踪偿付能力、内含价值披露与宏观利率路径。",
    ),
  },
];

const curvePoints: ProfitCurvePointDTO[] = [
  {
    statDate: "2026-04-01",
    dailyProfitAmount: 800,
    dailyProfitRate: 0.32,
    closedProfitAmount: 1200,
    closedProfitRate: 1.05,
  },
  {
    statDate: "2026-04-02",
    dailyProfitAmount: -200,
    dailyProfitRate: -0.08,
    closedProfitAmount: 1000,
    closedProfitRate: 0.88,
  },
  {
    statDate: "2026-04-03",
    dailyProfitAmount: 450,
    dailyProfitRate: 0.18,
    closedProfitAmount: 1450,
    closedProfitRate: 1.27,
  },
  {
    statDate: "2026-04-06",
    dailyProfitAmount: 620,
    dailyProfitRate: 0.25,
    closedProfitAmount: 2070,
    closedProfitRate: 1.81,
  },
  {
    statDate: "2026-04-07",
    dailyProfitAmount: -150,
    dailyProfitRate: -0.06,
    closedProfitAmount: 1920,
    closedProfitRate: 1.68,
  },
  {
    statDate: "2026-04-08",
    dailyProfitAmount: 380,
    dailyProfitRate: 0.15,
    closedProfitAmount: 2300,
    closedProfitRate: 2.01,
  },
  {
    statDate: "2026-04-09",
    dailyProfitAmount: 720,
    dailyProfitRate: 0.29,
    closedProfitAmount: 3020,
    closedProfitRate: 2.64,
  },
  {
    statDate: "2026-04-10",
    dailyProfitAmount: -80,
    dailyProfitRate: -0.03,
    closedProfitAmount: 2940,
    closedProfitRate: 2.57,
  },
  {
    statDate: "2026-04-13",
    dailyProfitAmount: 560,
    dailyProfitRate: 0.22,
    closedProfitAmount: 3500,
    closedProfitRate: 3.06,
  },
  {
    statDate: "2026-04-14",
    dailyProfitAmount: 340,
    dailyProfitRate: 0.14,
    closedProfitAmount: 3840,
    closedProfitRate: 3.36,
  },
  {
    statDate: "2026-04-15",
    dailyProfitAmount: -120,
    dailyProfitRate: -0.05,
    closedProfitAmount: 3720,
    closedProfitRate: 3.25,
  },
  {
    statDate: "2026-04-16",
    dailyProfitAmount: 480,
    dailyProfitRate: 0.19,
    closedProfitAmount: 4200,
    closedProfitRate: 3.67,
  },
  {
    statDate: "2026-04-17",
    dailyProfitAmount: 290,
    dailyProfitRate: 0.12,
    closedProfitAmount: 4490,
    closedProfitRate: 3.92,
  },
  {
    statDate: "2026-04-20",
    dailyProfitAmount: -200,
    dailyProfitRate: -0.08,
    closedProfitAmount: 4290,
    closedProfitRate: 3.75,
  },
  {
    statDate: "2026-04-21",
    dailyProfitAmount: 520,
    dailyProfitRate: 0.21,
    closedProfitAmount: 4810,
    closedProfitRate: 4.20,
  },
  {
    statDate: "2026-04-22",
    dailyProfitAmount: 180,
    dailyProfitRate: 0.07,
    closedProfitAmount: 4990,
    closedProfitRate: 4.36,
  },
  {
    statDate: "2026-04-23",
    dailyProfitAmount: -90,
    dailyProfitRate: -0.04,
    closedProfitAmount: 4900,
    closedProfitRate: 4.28,
  },
  {
    statDate: "2026-04-24",
    dailyProfitAmount: 410,
    dailyProfitRate: 0.16,
    closedProfitAmount: 5310,
    closedProfitRate: 4.64,
  },
  {
    statDate: "2026-04-27",
    dailyProfitAmount: 350,
    dailyProfitRate: 0.14,
    closedProfitAmount: 5660,
    closedProfitRate: 4.95,
  },
  {
    statDate: "2026-04-28",
    dailyProfitAmount: -150,
    dailyProfitRate: -0.06,
    closedProfitAmount: 5510,
    closedProfitRate: 4.82,
  },
  {
    statDate: "2026-04-29",
    dailyProfitAmount: 680,
    dailyProfitRate: 0.27,
    closedProfitAmount: 6190,
    closedProfitRate: 5.41,
  },
  {
    statDate: "2026-04-30",
    dailyProfitAmount: 220,
    dailyProfitRate: 0.09,
    closedProfitAmount: 6410,
    closedProfitRate: 5.60,
  },
  {
    statDate: "2026-05-01",
    dailyProfitAmount: 1200,
    dailyProfitRate: 0.48,
    closedProfitAmount: 7610,
    closedProfitRate: 6.65,
  },
  {
    statDate: "2026-05-04",
    dailyProfitAmount: -420,
    dailyProfitRate: -0.17,
    closedProfitAmount: 7190,
    closedProfitRate: 6.28,
  },
  {
    statDate: "2026-05-05",
    dailyProfitAmount: 880,
    dailyProfitRate: 0.35,
    closedProfitAmount: 8070,
    closedProfitRate: 7.05,
  },
  {
    statDate: "2026-05-06",
    dailyProfitAmount: 210,
    dailyProfitRate: 0.08,
    closedProfitAmount: 8280,
    closedProfitRate: 7.23,
  },
  {
    statDate: "2026-05-07",
    dailyProfitAmount: 450,
    dailyProfitRate: 0.18,
    closedProfitAmount: 8730,
    closedProfitRate: 7.63,
  },
  {
    statDate: "2026-05-08",
    dailyProfitAmount: -180,
    dailyProfitRate: -0.07,
    closedProfitAmount: 8550,
    closedProfitRate: 7.47,
  },
];

const closedTradeRows: ClosedTradeLineDTO[] = [
  {
    tradeId: "T20260501001",
    stockCode: "600036",
    stockName: "招商银行",
    sellShares: 500,
    sellPrice: 45.8,
    costPrice: 42.5,
    profitAmount: 1650,
    sellTime: "2026-05-01 14:30:00",
    reasonDisplay: "基本面 : 估值修复到位，获利了结",
  },
  {
    tradeId: "T20260428001",
    stockCode: "300274",
    stockName: "阳光电源",
    sellShares: 300,
    sellPrice: 88.5,
    costPrice: 75.2,
    profitAmount: 3990,
    sellTime: "2026-04-28 10:15:30",
    reasonDisplay: "技术面 : 达到目标价位",
  },
  {
    tradeId: "T20260425001",
    stockCode: "601012",
    stockName: "隆基绿能",
    sellShares: 800,
    sellPrice: 22.3,
    costPrice: 24.5,
    profitAmount: -1760,
    sellTime: "2026-04-25 13:45:00",
    reasonDisplay: "消息面 : 业绩不及预期，止损离场",
  },
];

export const userHoldingsMocks = {
  /** 与接口一致：持仓中的股票（deleted=0） */
  listAll(): AppUserHoldingLineDTO[] {
    return demoRowsOpen;
  },

  curvePoints,

  historyRows: histRows,

  closedTradeRows,

  async refresh(): Promise<string> {
    return "2026-05-06";
  },

  latestReview(): MonthlyReviewDetailDTO {
    return {
      id: "UREV900026040001",
      statYearMonth: "2026-04",
      title: "2026年04月 AI 交易复盘",
      summary:
        "四月共十二笔建仓与加仓，全部落入统计区间。理由以基本面略占优，龙头白酒、动力电池与优质银行为底仓；技术面对应光伏休整与银行补涨；消息面覆盖券商弹性与半导体预期，适合小仓位验证。",
      bodyText:
        "统计区间：2026-04-01 至 2026-04-30。归因对象为当月全部建仓与加仓流水（十二笔），按您自书的「理由类型 + 具体说明」归档。\n\n一、结构概览\n本月基本面、技术面、消息面记录条数之比约为 6:3:3。白酒与新能源车链条、以及高股息银行，构成本月基本面叙述主线；技术面多出现在板块休整与补涨共振阶段；券商与半导体的消息面受风险偏好与政策叙事扰动更大，价格弹性高、换手快。\n\n二、有效性观察\n在可核验样本中，基本面记录更易与财报节奏、产销与利率路径对照，事后解释力相对稳定。技术面笔数不多，但单侧波动大，对入场时点与止损纪律更敏感，易混入噪声交易。消息面需区分「预期差兑现」与单纯情绪放大，后者往往表现为短周期回撤。\n\n三、下月可执行改进\n建议为每笔流水绑定至少一个可核对的时间锚（例如财报披露日、行业库存结算节点、关键政策落地窗口），并在备注里写清若锚点证伪时的减仓条件，减少同一事件被三类理由重复诠释的模糊空间。\n\n本报告仅供个人交易动机归档与自评，不构成任何投资建议。",
      motivationChartJson:
        '{"segments":[{"motivation":"基本面","tradeCount":6,"effectiveCount":4,"ineffectiveCount":2,"pct":66.67,"ineffectivePct":33.33,"note":"白酒·动力电池·保险银行等"},{"motivation":"技术面","tradeCount":3,"effectiveCount":2,"ineffectiveCount":1,"pct":66.67,"ineffectivePct":33.33,"note":"光伏休整与银行补涨结构"},{"motivation":"消息面","tradeCount":3,"effectiveCount":1,"ineffectiveCount":2,"pct":33.33,"ineffectivePct":66.67,"note":"券商交投与半导体叙事"}],"chartHint":{"pieSlice":"tradeCount","barSeries":["effectiveCount","ineffectiveCount"]}}',
      periodStartAt: "2026-04-01 00:00:00",
      periodEndAt: "2026-04-30 23:59:59",
    };
  },

  listReviews(): MonthlyReviewListDTO {
    const d = userHoldingsMocks.latestReview();
    return {
      rows: [
        {
          id: String(d.id),
          statYearMonth: d.statYearMonth,
          title: String(d.title),
          summary: String(d.summary ?? "").slice(0, 80),
        },
        {
          id: "UREV900026030001",
          statYearMonth: "2026-03",
          title: "2026年03月 AI 交易复盘",
          summary: "三月风险偏好温和回升，仓位向消费与新能源链条倾斜；基本面理由的内部一致性优于消息面。",
        },
      ],
    };
  },

  detail(id: string): MonthlyReviewDetailDTO | null {
    if (id === "UREV900026030001") {
      return {
        id,
        statYearMonth: "2026-03",
        title: "2026年03月 AI 交易复盘",
        summary:
          "三月风险偏好温和回升，仓位向消费与新能源链条倾斜；基本面理由的内部一致性优于消息面，适合作为四月高密度交易前的节奏对照。",
        bodyText:
          "统计区间：2026-03-01 至 2026-03-31。以下为历史区间归档样例，用于观察情绪波动期的理由使用习惯。\n\n样本结构上，基本面记录仍占主导，但消息面在月末脉冲中占比抬升，容易出现「叙事先行、验证滞后」。技术面失败笔在震荡市中比例偏高，提示入场规则需要与波动区间匹配。\n\n若与四月对照阅读，可关注两端差异：三月更像试探性回补，四月则更集中在龙头确定性上的加码。\n\n本报告仅供个人交易动机归档与自评，不构成任何投资建议。",
        motivationChartJson:
          '{"segments":[{"motivation":"基本面","tradeCount":12,"effectiveCount":8,"ineffectiveCount":4,"pct":66.67,"ineffectivePct":33.33,"note":"消费与新能源链条"},{"motivation":"消息面","tradeCount":9,"effectiveCount":3,"ineffectiveCount":6,"pct":33.33,"ineffectivePct":66.67,"note":"政策脉冲与补涨交叉"},{"motivation":"技术面","tradeCount":7,"effectiveCount":2,"ineffectiveCount":5,"pct":28.57,"ineffectivePct":71.43,"note":"震荡市回撤磨损"}],"chartHint":{"pieSlice":"tradeCount","barSeries":["effectiveCount","ineffectiveCount"]}}',
        periodStartAt: "2026-03-01 00:00:00",
        periodEndAt: "2026-03-31 23:59:59",
      };
    }
    return userHoldingsMocks.latestReview();
  },

  openBuy(p: {
    stockCode: string;
    buyPrice: number;
    buyShares: number;
    buyTime: string;
    reasonType: string;
    reasonDetail: string;
  }): boolean {
    return p.stockCode.length > 0 && p.buyPrice > 0 && p.buyShares > 0 && p.buyTime.trim() !== "";
  },

  addBuy(): boolean {
    return true;
  },

  sell(): boolean {
    return true;
  },

  resetHoldings(): boolean {
    return true;
  },
};
